import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Link, useParams } from "react-router-dom"; // Import useParams here
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios"; // Import axios
import { baseurl, imageUrl } from "../../Baseurl"; // Assuming you have this URL defined
import { Edit, Eye, Trash2 } from "react-feather";
// Import DataTable
import DataTable from "react-data-table-component";
// Import icons for grid/list toggle (you can use FontAwesome or Material Icons)
import { FaTh, FaList } from "react-icons/fa";
import Swal from "sweetalert2";


const AdminSellerListing = () => {
  const { seller_id } = useParams(); // Use useParams directly here
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState("grid");


    // Filters
    const [searchText, setSearchText] = useState("");
    const [conditionFilter, setConditionFilter] = useState("");
    const [typeFilter, setTypeFilter] = useState("");
    const [currencyFilter, setCurrencyFilter] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);





const handleDeleteListing = async (listingId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseurl}deleteListingById/${listingId}`);
          Swal.fire("Deleted!", "Your listing has been deleted.", "success").then(() => {
            fetchListings(); // Refresh list
          });
        } catch (error) {
          Swal.fire("Error!", "Failed to delete listing. Please try again.", "error");
        }
      }
    });
  };






  // Fetch listings from API
  const fetchListings = async () => {
    if (!seller_id) {
      console.error("Seller ID is missing.");
      return;
    }

    try {
      const response = await axios.get(
        `${baseurl}/fetchSellerListingById/${seller_id}`
      );
      if (response.data && response.data.data) {
        setListings(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching listings:", error);
    } finally {
      setLoading(false);
    }
  };

  // Call fetchListings on component mount
  useEffect(() => {
    fetchListings();
  }, [seller_id]); // Add seller_id as a dependency

 // Filter listings based on user input
  const filteredListings = listings.filter((listing) => {
    const createdDate = new Date(listing.created_at);
    return (
      listing.title.toLowerCase().includes(searchText.toLowerCase()) &&
      (!conditionFilter || listing.condition === conditionFilter) &&
      (!typeFilter || listing.type === typeFilter) &&
      (!currencyFilter || listing.currency === currencyFilter) &&
      (!fromDate || createdDate >= fromDate) &&
      (!toDate || createdDate <= toDate)
    );
  });

  const uniqueOptions = (key) => [...new Set(listings.map((item) => item[key]).filter(Boolean))];

  const columns = [
    { name: "Title", selector: (row) => row.title, sortable: true },
    { name: "Condition", selector: (row) => row.condition, sortable: true },
    { name: "Type", selector: (row) => row.type, sortable: true },
    { name: "Price", selector: (row) => row.price, sortable: true },
    { name: "Currency", selector: (row) => row.currency, sortable: true },
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
    // {
    //   name: "Action",
    //   cell: (row) => (
    //     <Link to={`/seller/edit-listing/${row.listing_unique_id}`} className="btn btn-primary btn-sm">
    //       Edit
    //     </Link>
    //   ),
    // },
  ];

  // Render listings in grid view
     const renderGridView = () => {
       const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
   
       return (
         <div className="row g-1">
           {filteredListings.map((listing) => {
             const imageFile = listing.listing_images.find(
               (img) => img && imageExtensions.some((ext) => img.toLowerCase().endsWith(ext))
             );
   
             return (
               <div key={listing.listing_unique_id} className="col-md-3">
                 <div className="card">
                   <div className="card-body p-1">
                     <div>
                       <img
                         src={
                           imageFile
                             ? `${imageUrl}listing/${imageFile}`
                             : "/path/to/placeholder.jpg"
                         }
                         className="img-fluid gridimg"
                         alt="Listing"
                       />
                     </div>
                     <h5 className="card-title mt-1">{listing.title}</h5>
                     <p className="card-text">{listing.condition}</p>
                     <p className="card-text">
                       {listing.price} {listing.currency}
                     </p>
                     <div className="d-flex justify-content-between mt-2 mb-2">
                       <Link to={`/product/${listing.slug}`} target="_blank" className="btn btn-info btn-sm">
                         <Eye size={17} /> View
                       </Link>
                       {/* <Link to={`/seller/edit-listing/${listing.listing_unique_id}`} className="btn btn-warning btn-sm">
                         <Edit size={17} /> Edit
                       </Link> */}
                     </div>
                     <button onClick={() => handleDeleteListing(listing.listing_unique_id)} className="btn btn-danger btn-sm">
                       <Trash2 size={17} /> Delete
                     </button>
                   </div>
                 </div>
               </div>
             );
           })}
         </div>
       );
     };
    
    

  // Render listings in list view (DataTable)
  const renderListView = () => {
    return (
      <DataTable
        title="Seller Listings"
        columns={columns} 
        data={filteredListings}
        progressPending={loading} // Show loading while fetching
        pagination // Enable pagination
      />
    );
  };

  return (
    <>
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-12">
                






<div className="reviewcls text-start">
                <div className="row mb-3 g-1">
                  <div className="col-md-6">
                    <h4 className="selh1">My Listings</h4>
                  </div>
                  <div className="col-md-6 text-end">
                    <button
                      className={`btn btn-outline-primary ${viewMode === "grid" ? "active submitbtnn w-25 me-2" : ""}`}
                      onClick={() => setViewMode("grid")}
                    >
                      <FaTh /> Grid View
                    </button>
                    <button
                      className={`btn btn-outline-primary ${viewMode === "list" ? "active submitbtnn w-25 me-2" : ""}`}
                      onClick={() => setViewMode("list")}
                    >
                      <FaList /> List View
                    </button>
                  </div>
                </div>
                <div className="row g-1 mb-2">
                  <div className="col-md-4">
                    <input
                      type="text"
                      placeholder="Search by Title"
                      className="form-control"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <select
                      className="form-control"
                      value={conditionFilter}
                      onChange={(e) => setConditionFilter(e.target.value)}
                    >
                      <option value="">All Conditions</option>
                      {uniqueOptions("condition").map((cond) => (
                        <option key={cond} value={cond}>
                          {cond}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <select
                      className="form-control"
                      value={typeFilter}
                      onChange={(e) => setTypeFilter(e.target.value)}
                    >
                      <option value="">All Types</option>
                      {uniqueOptions("type").map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <select
                      className="form-control"
                      value={currencyFilter}
                      onChange={(e) => setCurrencyFilter(e.target.value)}
                    >
                      <option value="">All Currencies</option>
                      {uniqueOptions("currency").map((cur) => (
                        <option key={cur} value={cur}>
                          {cur}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div className="col-md-2">
                    <DatePicker
                      selected={fromDate}
                      onChange={(date) => setFromDate(date)}
                      placeholderText="From"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-2">
                    <DatePicker
                      selected={toDate}
                      onChange={(date) => setToDate(date)}
                      placeholderText="To"
                      className="form-control"
                    />
                  </div> */}
                </div>
                <hr />
                {viewMode === "grid" ? renderGridView() : renderListView()}
              </div>










              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminSellerListing;
